import { defineNuxtPlugin, useHead } from '#imports';
import { MergeHead } from '@unhead/schema';
import { GLOBAL_CONFIG } from '~/configs/environment/environment';
// 阿里云 arms 监控
export default defineNuxtPlugin(nuxtApp => {
  let script: MergeHead['script'] = {};

  script = {
    src: GLOBAL_CONFIG.envConfig.assetsBase + '/assets/js/shence.js',
    tagPosition: 'bodyClose',
  };

  useHead({
    script: [script],
  });
});
